import AnalyticalWorksheetService from "./AnalyticalWorksheetService";
export default class ModuleFiveService {
  
  static amountCalculate(item, depreciation){
    let amount = 0;
    if (depreciation.toString() == "true")
      amount = (item.quantity * item.value * (item.lifetime / 100));
    else
      amount = item.quantity * item.value / item.lifetime;
    
    return amount;
  }
  static getAmountMonthly(selectedItems, depreciation){
    if(!selectedItems)
      return 0
  
    let amount = 0
    for (let i = 0; i < selectedItems.length; i++)
      amount += this.amountCalculate(selectedItems[i], depreciation)
         
    return amount
  }
  static getAmountMonthlyByEmployee(attachment, amountMonthly, numberOfEmployees) {
    let amount = 0
    if(attachment === "uniformsAndEPIs"){
       return amountMonthly
    }else {
      if(numberOfEmployees > 0)
        amount = amountMonthly / numberOfEmployees;
    }
    return amount 
  }
  static async getAmountOfAttachment(sheetId, moduleFive, attachment){
    let sheetBondId = moduleFive[attachment].bond ? moduleFive[attachment].bond : sheetId

    let bonds             = await AnalyticalWorksheetService.getBonds(sheetBondId, attachment)
    let selectedItems     = await this.getSelectItems(bonds, attachment)
    let amountMonthly     = await this.getAmountMonthly(selectedItems, moduleFive[attachment].depreciation)
    let numberOfEmployees = await this.getNumberOfEmployees(bonds)

    return await this.getAmountMonthlyByEmployee(attachment, amountMonthly, numberOfEmployees)
  }
  static async getAmountOfModuleFive(sheetId, moduleFive){
    let amount = await this.getAmountOfAttachment(sheetId, moduleFive, 'consumables') +
                await this.getAmountOfAttachment(sheetId, moduleFive, 'equipments') +
                await this.getAmountOfAttachment(sheetId, moduleFive, 'uniformsAndEPIs') + 
                await this.getAmountOfAttachment(sheetId, moduleFive, 'utensils') + 
                await this.getOthers(moduleFive.others)
    return amount
  }
  static getNumberOfEmployees(bonds){
    if(!bonds)
      return 0
    
    let numberOfEmployees = 0
    
    for (let i = 0; i < bonds.length; i++)
      numberOfEmployees += bonds[i].header ? parseInt(bonds[i].header.numberOfEmployees) : 0
    
    return numberOfEmployees
  }
  static getOthers(others){
    if(!others)
      return 0
    let amount = 0
    for (let i = 0; i < others.length; i++) {
      amount += others[i].value;
    }
    return amount
  }
  static getSelectItems(bonds, attachment){
    if(!bonds)
      return []

    for (let i = 0; i < bonds.length; i++) {
      if(bonds[i].moduleFive[attachment].items.length > 0)
        return bonds[i].moduleFive[attachment].items
    }
    return []
  }
  static getSubTotalOfAttachment(items) {
    if(!items)
      return 0

    let amount = 0

    for (let i = 0; i < items.length; i++)
      amount += items[i].value * items[i].quantity
    
    return amount
  }
} // class



// WEBPACK FOOTER //
// ./src/service/ModuleFiveService.js